import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import Logo from "../components/Logo";

export default function Register() {
  const { register, user } = useAuth();
  const navigate = useNavigate();
  const [displayName, setDisplayName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (user && typeof user === "object") navigate("/dashboard", { replace: true });
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }
    setSubmitting(true);
    const res = await register(email, password, displayName);
    setSubmitting(false);
    if (res.ok) {
      toast.success("Your space is ready.");
      navigate("/dashboard", { replace: true });
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="container-x py-16 lg:py-24" data-testid="register-page">
      <div className="max-w-md mx-auto card-soft p-8 lg:p-10">
        <Link to="/" className="inline-block mb-6" data-testid="register-logo">
          <Logo size={44} wordmarkClass="text-xl" />
        </Link>
        <h1 className="font-outfit text-3xl font-medium text-ink">Start your Hysteregistry</h1>
        <p className="font-manrope text-sm text-ink-soft mt-2">
          Takes less than two minutes. Free, always.
        </p>

        <form onSubmit={handleSubmit} className="mt-8 space-y-4">
          <div>
            <label className="font-manrope text-sm text-ink mb-1 block" htmlFor="display_name">Your name</label>
            <input
              id="display_name"
              type="text"
              required
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
              className="input-soft"
              placeholder="Sarah M."
              data-testid="register-name-input"
            />
          </div>
          <div>
            <label className="font-manrope text-sm text-ink mb-1 block" htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-soft"
              data-testid="register-email-input"
            />
          </div>
          <div>
            <label className="font-manrope text-sm text-ink mb-1 block" htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              autoComplete="new-password"
              required
              minLength={6}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-soft"
              data-testid="register-password-input"
            />
            <p className="font-manrope text-xs text-ink-soft mt-1">At least 6 characters.</p>
          </div>
          {error && (
            <div className="tag-pill !bg-red-50 !text-red-700" data-testid="register-error">
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={submitting}
            className="btn-primary w-full"
            data-testid="register-submit-btn"
          >
            {submitting ? "Creating your space…" : "Create account"}
          </button>
        </form>

        <p className="mt-6 font-manrope text-sm text-ink-soft text-center">
          Already have an account?{" "}
          <Link to="/login" className="text-brand font-medium hover:underline" data-testid="register-to-login-link">
            Log in
          </Link>
        </p>
      </div>
    </div>
  );
}
